import { Component } from "@angular/core";

@Component({
  selector: "med-card",
  templateUrl: "./med-card.component.html",
  styleUrls: ["./med-card.component.scss"],
})
export class MedCardComponent {}
